export default "/Frontend/dist/pdf-black.9431bde22282fe2983814ecc32bcdf11.svg";